import type {
    GeminiImageEditOpenRouterType,
    ImageEffectType,
    OpenAiImageEditOpenRouterType,
    OpenRouterImageToImageType
} from '@/typings/customilyElements/imageEffectType';
import { EffectType } from '@/typings/customilyElements/imageEffectType';
import { normalizeOpenRouterImageParams } from '@/components/DesignStudio/ImageEffectsProperties/core/openrouter';

type LegacyImageEditOpenRouter = GeminiImageEditOpenRouterType | OpenAiImageEditOpenRouterType;

const isLegacyImageEditOpenRouter = (effect: ImageEffectType): effect is LegacyImageEditOpenRouter =>
    effect.type === EffectType.GEMINI_IMAGE_EDIT_OPENROUTER || effect.type === EffectType.OPENAI_IMAGE_EDIT_OPENROUTER;

// Same models the storefront redirects these legacy effects to; params take the catalog defaults.
export const upgradeLegacyOpenRouterImageEdit = (effect: ImageEffectType): ImageEffectType => {
    if (!isLegacyImageEditOpenRouter(effect)) return effect;

    const model =
        effect.type === EffectType.OPENAI_IMAGE_EDIT_OPENROUTER
            ? effect.isMini
                ? 'openai/gpt-image-1-mini'
                : 'openai/gpt-image-2.5-sunburst'
            : 'google/gemini-3.1-flash-image';

    return normalizeOpenRouterImageParams({
        ...(effect.id && { id: effect.id }),
        ...(effect.presetId && { presetId: effect.presetId }),
        type: EffectType.OPENROUTER_IMAGE_TO_IMAGE,
        prompt: effect.prompt,
        ...(effect.referenceImageUrl && { referenceImageUrl: effect.referenceImageUrl }),
        model
    } as OpenRouterImageToImageType);
};
